import type {
  EnhancedDesignType,
  PassTemplateApiResponse,
} from '../../../../store/types/template';

interface TemplateDataLike {
  data?: {
    id?: string;
    attributes?: Partial<
      Pick<PassTemplateApiResponse['data']['attributes'], 'appleEnhancedDesign'>
    >;
  };
}

export const getEnhancedDesignType = (
  templateData: TemplateDataLike | undefined,
  templateId: string
): EnhancedDesignType | undefined => {
  if (templateData?.data?.id !== templateId) return undefined;
  return templateData?.data?.attributes?.appleEnhancedDesign?.type ?? undefined;
};
